(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

class NavSlider extends HTMLElement {
  constructor() {
    super();
    this.index = 0;
    this.autoSlide = null;
    this.slidesPerView = 3;
    this.startX = 0;
    this.currentX = 0;
    this.isDragging = false;

    // defaults
    this.showArrows = this.getAttribute("arrow") !== "false";
    this.enableSwipe = this.getAttribute("swipe") !== "false";
    this.showDots = this.getAttribute("dot") === "true";
  }

  connectedCallback() {
    const slides = Array.from(this.children);

    // build inner html based on attributes
    this.innerHTML = `
      ${this.showArrows ? '<button class="prev">&#10094;</button>' : ""}
      <div class="slider-track"></div>
      ${this.showArrows ? '<button class="next">&#10095;</button>' : ""}
      ${this.showDots ? '<div class="slider-dots"></div>' : ""}
    `;

    this.track = this.querySelector(".slider-track");
    slides.forEach(slide => this.track.appendChild(slide));

    this.slides = this.querySelectorAll(".navslide");
    this.slideCount = this.slides.length;

    // arrows
    if (this.showArrows) {
      this.prevBtn = this.querySelector(".prev");
      this.nextBtn = this.querySelector(".next");

      this.nextBtn.addEventListener("click", () => {
        this.nextSlide();
        this.resetAuto();
      });
      this.prevBtn.addEventListener("click", () => {
        this.prevSlide();
        this.resetAuto();
      });
    }

    // swipe
    if (this.enableSwipe) {
      this.track.addEventListener("touchstart", e => this.touchStart(e), { passive: true });
      this.track.addEventListener("touchmove", e => this.touchMove(e), { passive: true });
      this.track.addEventListener("touchend", () => this.touchEnd());
    }

    // dots
    if (this.showDots) {
      this.dotsContainer = this.querySelector(".slider-dots");
      this.renderDots();
    }

    this.updateSlidesPerView();
    window.addEventListener("resize", () => this.updateSlidesPerView());

    this.updateSlider();
  }

  updateSlidesPerView() {
    this.slidesPerView = window.innerWidth < 768 ? 2 : 3;

    this.slides.forEach(slide => {
      slide.style.flex = `0 0 ${100 / this.slidesPerView}%`;
    });

    if (this.showArrows) {
      if (this.slidesPerView === 2) {
        this.prevBtn.style.display = "none";
        this.nextBtn.style.display = "none";
        this.stopAuto();
      } else {
        this.prevBtn.style.display = "block";
        this.nextBtn.style.display = "block";
        this.startAuto();
      }
    }

    this.updateSlider();
  }

  updateSlider() {
    this.track.style.display = "flex";
    this.track.style.transition = "transform 0.3s ease";
    this.track.style.transform = `translateX(-${this.index * (100 / this.slidesPerView)}%)`;

    if (this.showDots) this.updateDots();
  }

  nextSlide() {
    this.index++;
    if (this.index > this.slideCount - this.slidesPerView) this.index = 0;
    this.updateSlider();
  }

  prevSlide() {
    this.index--;
    if (this.index < 0) this.index = this.slideCount - this.slidesPerView;
    this.updateSlider();
  }

  startAuto() {
    this.stopAuto();
    this.autoSlide = setInterval(() => this.nextSlide(), 3000);
  }

  stopAuto() {
    clearInterval(this.autoSlide);
  }

  resetAuto() {
    if (this.slidesPerView === 3) {
      this.stopAuto();
      this.startAuto();
    }
  }

  // --- Dots ---
  renderDots() {
    this.dotsContainer.innerHTML = "";
    for (let i = 0; i <= this.slideCount - this.slidesPerView; i++) {
      const dot = document.createElement("span");
      dot.className = "dot";
      dot.addEventListener("click", () => {
        this.index = i;
        this.updateSlider();
        this.resetAuto();
      });
      this.dotsContainer.appendChild(dot);
    }
    this.updateDots();
  }

  updateDots() {
    const dots = this.dotsContainer.querySelectorAll(".dot");
    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === this.index);
    });
  }

  // --- Touch Swipe Methods ---
  touchStart(e) {
    this.startX = e.touches[0].clientX;
    this.isDragging = true;
  }

  touchMove(e) {
    if (!this.isDragging) return;
    this.currentX = e.touches[0].clientX;
  }

  touchEnd() {
    if (!this.isDragging) return;
    const diff = this.startX - this.currentX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) this.nextSlide();
      else this.prevSlide();
    }
    this.isDragging = false;
  }
}

customElements.define("nav-slider", NavSlider);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const cartForm = document.querySelector('.cart-items');
  const cartErrors = document.querySelector('.cart-errors');
  let updateTimeout;

  // Format money consistently
  const formatMoney = (cents) => {
    return (cents/100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  };

  // Update cart UI elements
  const updateCartUI = (cart) => {
    // Update subtotal
    const subtotalElement = document.querySelector('[data-subtotal]');
    subtotalElement.textContent = `$${formatMoney(cart.total_price)}`;

    // Update shipping (assuming free shipping over $100)
    const shippingElement = document.querySelector('[data-shipping]');
    const shippingCost = cart.total_price >= 10000 ? 0 : 1000;
    shippingElement.textContent = shippingCost === 0 ? 'Free' : `$${formatMoney(shippingCost)}`;

    // Update total
    const totalElement = document.querySelector('[data-total]');
    totalElement.textContent = `$${formatMoney(cart.total_price + shippingCost)}`;

    // If cart is empty, redirect to cart page
    if (cart.item_count === 0) {
      window.location.href = '/cart';
    }
  };

  // Handle quantity changes with debouncing
  const handleQuantityChange = (itemKey, quantity, element) => {
    clearTimeout(updateTimeout);
    
    // Add loading state
    const cartItem = element.closest('.cart-item');
    const priceElement = cartItem.querySelector('.cart-item__price');
    const summaryElements = document.querySelectorAll('[data-subtotal], [data-shipping], [data-total]');
    
    cartItem.classList.add('loading');
    summaryElements.forEach(el => el.classList.add('loading'));

    updateTimeout = setTimeout(() => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(cart => {
        // Update item price
        const item = cart.items.find(i => i.key === itemKey);
        if (item) {
          priceElement.textContent = `$${formatMoney(item.final_line_price)}`;
        }

        // Update cart totals
        updateCartUI(cart);

        // Remove loading states
        cartItem.classList.remove('loading');
        summaryElements.forEach(el => el.classList.remove('loading'));

        // Remove item if quantity is 0
        if (quantity === 0) {
          cartItem.style.opacity = 0;
          setTimeout(() => {
            cartItem.remove();
          }, 300);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        cartErrors.textContent = 'There was an error updating your cart. Please try again.';
        cartErrors.style.display = 'block';
        
        // Remove loading states
        cartItem.classList.remove('loading');
        summaryElements.forEach(el => el.classList.remove('loading'));
      });
    }, 500); // Debounce for 500ms
  };

  // Quantity adjustment
  document.querySelectorAll('.js-qty-minus').forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentNode.querySelector('.quantity-input');
      const newQty = parseInt(input.value) - 1;
      if (newQty >= 0) {
        input.value = newQty;
        handleQuantityChange(input.dataset.itemKey, newQty, input);
      }
    });
  });

  document.querySelectorAll('.js-qty-plus').forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentNode.querySelector('.quantity-input');
      const newQty = parseInt(input.value) + 1;
      input.value = newQty;
      handleQuantityChange(input.dataset.itemKey, newQty, input);
    });
  });

  // Handle direct quantity input
  document.querySelectorAll('.quantity-input').forEach(input => {
    input.addEventListener('change', function() {
      const newQty = parseInt(this.value);
      if (newQty >= 0) {
        handleQuantityChange(this.dataset.itemKey, newQty, this);
      }
    });
  });

  // Remove item
  document.querySelectorAll('.remove-button').forEach(button => {
    button.addEventListener('click', function() {
      const itemKey = this.dataset.itemKey;
      handleQuantityChange(itemKey, 0, this);
    });
  });

  // Handle coupon form submission
  const discountForm = document.getElementById('discount-form');
  const couponError = document.getElementById('coupon-error');

  discountForm.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const formData = new FormData(this);
    const couponCode = formData.get('discount');
    
    // Add loading state to form
    this.classList.add('loading');
    
    fetch('/discount/' + couponCode)
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          couponError.textContent = 'Invalid coupon code';
          couponError.style.display = 'block';
        } else {
          // Refresh cart data to show updated prices
          return fetch('/cart.js');
        }
      })
      .then(response => response.json())
      .then(cart => {
        if (cart) {
          updateCartUI(cart);
          couponError.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Error:', error);
        couponError.textContent = 'There was an error applying the coupon. Please try again.';
        couponError.style.display = 'block';
      })
      .finally(() => {
        discountForm.classList.remove('loading');
      });
  });
});

  } catch(e) { console.error(e); }
})();
})();
